module.exports = __webpack_public_path__ + "static/media/assPresidente.6fb2636a.png";